// FLUXO 06 · ELO 2 — preventive_due_card WS card store.
//
// The engine preventive-due scanner (behind PREVENTIVE_SCHEDULER_ENABLED) pushes
// a `preventive_due_card` frame to the planner: "N plan(s) due — generate the
// WO?". The OS is born by HUMAN confirmation, so this store only holds the
// latest informational card; it never auto-acts. With the engine flag OFF no
// frame is ever sent, so this store stays empty (no UX change).
import { create } from 'zustand'
import type { PreventiveDueCardEvent } from '../features/maintenance-plans/types'

interface PreventiveDueState {
  card: PreventiveDueCardEvent | null
  setCard: (card: PreventiveDueCardEvent) => void
  dismiss: () => void
}

export const usePreventiveDueStore = create<PreventiveDueState>((set) => ({
  card: null,
  setCard(card) {
    set({ card })
  },
  dismiss() {
    set({ card: null })
  },
}))
